import { useEffect, useRef } from "react";

const DEFAULT_SRC = "https://salesiq.zohopublic.eu/widget?wc=siqe2ce355b0aac77a60353fa5689d2f197fafc35097192e1cac04446af605d8d828f75a9bf8ac80215031facb64cfefe95";
const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

/**
 * ZohoWidgetLoader
 * - GETs the provided integrity-generation endpoint
 * - reads `integrity` from the JSON response and injects the script element
 * - does not load on pages where `loadWhen()` returns false
 */
export default function ZohoWidgetLoader({
  scriptSrc = DEFAULT_SRC,
  scriptId = "zsiqscript",
  loadWhen = () => true,
}) {
  useEffect(() => {
    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, [scriptId]);

  useEffect(() => {
    if (!loadWhen()) return;

    async function fetchAndInject() {
      try {
        let endpoint = apiUrl + "/generate-integrity";

        if (enviromentUrl !== "") {
            if (endpoint.includes("?")) {
                endpoint += `&env=${enviromentUrl}`;
            } else {
                endpoint += `?env=${enviromentUrl}`;
            }
        }

        const res = await fetch(endpoint, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("integrity endpoint returned " + res.status);
        const json = await res.json();

        const integrity = json?.integrity; // e.g. "sha384-..."
        // prepare vendor global
        window.$zoho = window.$zoho || {};
        window.$zoho.salesiq = window.$zoho.salesiq || { ready() {} };

        // remove previous script if present
        const prev = document.getElementById(scriptId);
        if (prev) prev.remove();

        const s = document.createElement("script");
        s.id = scriptId;
        s.defer = true;
        s.crossOrigin = "anonymous";
        if (integrity) s.integrity = integrity;
        s.src = scriptSrc;

        document.body.appendChild(s);
      } catch (err) {
        console.error("ZohoWidgetLoader error:", err);
      }
    }

    fetchAndInject();
  }, [scriptSrc, scriptId, loadWhen]);

  return null;
}
